module.exports = __webpack_public_path__ + "img/homepage_0--mobile.ba44299e.jpg";